import { getAxiosInstance } from '@/services/axiosConfig';
import { RunCostResponse } from '../api.shared.types';
import { BatchCostRequest } from './batches.api.types';

const axiosInstance = getAxiosInstance();

export const getBatchCostApi = async ({ recipeId, numberOfRuns, nodes, edges }: BatchCostRequest) => {
  const res = await axiosInstance.post<RunCostResponse>(
    `/v1/batches/recipes/${recipeId}/cost`,
    { numberOfRuns, nodes, edges },
    { 'axios-retry': { retries: 0 } },
  );
  return res.data;
};
